import { render, staticRenderFns } from "./MerchantStatistics.vue?vue&type=template&id=5abfd196&"
import script from "./MerchantStatistics.vue?vue&type=script&lang=ts&"
export * from "./MerchantStatistics.vue?vue&type=script&lang=ts&"
import style0 from "./MerchantStatistics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MerchantStatistics.vue"
export default component.exports